import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faUser, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { useWishlist } from '../context/WishlistContext';
import '../StylesComponents/subheader.css';

function SubHeader({ currentUser, toggleWishlist, isVisible }) {
  const { wishlistItems } = useWishlist();
  const location = useLocation();

  const getLinkClass = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className={`subheader-container ${!isVisible ? 'hidden' : ''}`}>
      <div className="subheader-left">
        <nav className="category-links">
          <Link to="/mens" className={getLinkClass('/mens')}>Mens</Link>
          <Link to="/womens" className={getLinkClass('/womens')}>Womens</Link>
          <Link to="/kids" className={getLinkClass('/kids')}>Kids</Link>
          <Link to="/shoes" className={getLinkClass('/shoes')}>Shoes</Link>
          <Link to="/accessories" className={getLinkClass('/accessories')}>Accessories</Link>
        </nav>
      </div>

      <div className="subheader-right">
        <div className="icon-links">
          {!currentUser ? (
            <Link 
              to="/signin" 
              className="subheader-auth-link subheader-auth-icon-desktop-hide"
            >
              <FontAwesomeIcon icon={faSignInAlt} className="subheader-icon" />
            </Link>
          ) : (
            <Link 
              to="/profile" 
              className="subheader-auth-link subheader-auth-icon-desktop-hide"
            >
              <FontAwesomeIcon icon={faUser} className="subheader-icon" />
            </Link>
          )}
          <div className="wishlist-icon-wrapper" onClick={toggleWishlist}>
            <FontAwesomeIcon icon={faHeart} className="subheader-icon wishlist-icon" />
            {wishlistItems && wishlistItems.length > 0 && (
              <span className="wishlist-count">{wishlistItems.length}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubHeader;
